import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router'
import thunkMiddleware from 'redux-thunk';
import { createBrowserHistory } from 'history';

// Reducers.
import createRootReducer from 'reducers/rootReducer';

export const history = createBrowserHistory();

export default function configureStore(initialState) {
  const store = createStore(
    createRootReducer(history),
    initialState,
    compose(
      applyMiddleware(
        thunkMiddleware,
        routerMiddleware(history),
      ),
    ),
  );
  return store;
}
